var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"module-self-diagnosis-status-badge",attrs:{"pill":"","variant":_vm.variant},domProps:{"textContent":_vm._s(_vm.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }